import psl from 'psl';

export const passwordValidation = value =>
  value && value.length >= 8 ? undefined : 'Password too short';
export const pinNumberValidation = value =>
  value && value.length === 4 && /^\d+$/.test(value)
    ? undefined
    : 'PIN must be a 4 digit number';
export const passwordWarn = value =>
  value && value.length >= 12 ? undefined : 'Weak password';
export const passwordConfirm = (value, allValues) =>
  value && value === allValues.password ? undefined : 'Passwords don\'t match';

export const registrationPasswordValidation = value =>
  value && value.length >= 8 ? undefined : 'Password too short';
export const registrationPasswordWarn = value =>
  value && value.length >= 12 ? undefined : 'Weak password';
export const registrationPasswordConfirm = (value, allValues) =>
  value && value === allValues.password ? undefined : 'Passwords don\'t match';

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;
export const minLength8 = minLength(8);
export const minLength6 = minLength(6);
export const minLength16 = minLength(16);
export const maxLength16 = maxLength(16);
export const maxLength255 = maxLength(255);

export const positiveNumber = value =>
  value && !isNaN(Number(value)) && Number(value) > 0
    ? undefined
    : 'Must be a positive number';
export const requiredField = value =>
  value ? undefined : 'This field is required';
export const requiredBooleanField = value =>
  value || value === false ? undefined : 'This field is required';
export const emailValidation = value =>
  !value || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined;
export const dateOfBirthRequired = value =>
  value && value.birthday_day && value.birthday_month && value.birthday_year
    ? undefined
    : 'Date of birth is required';
export const phoneNumber = value =>
  value && !/^\d{7,}$/.test(value)
    ? 'Please enter a minimum of 7 digits only.'
    : undefined;
export function domainValid(value) {
  const split = value.split('/');
  let domain;
  if (value.startsWith('https://') || value.startsWith('http://')) {
    domain = split[2];
  } else {
    return 'Invalid URL. Domain must begin with http:// or https://';
  }
  return psl.isValid(domain)
    ? undefined
    : 'Invalid URL. Please enter full domain name.';
}
export const maxAmount = value =>
  value && Number(value) <= 1000000
    ? undefined
    : 'Maximum value of $1,000,000.';
